<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">جزئیات کاربر</h3>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <user-info :user-info="userInfo" />
        </v-col>

        <v-col cols="12" md="10">
          <v-card>
            <v-card-text>
              <v-tabs v-model="tab" grow>
                <v-tab key="companies">شرکت ها</v-tab>
                <v-tab key="wallet">کیف پول</v-tab>
                <v-tab key="referred">کاربران زیرمجموعه</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" :reverse="true">
                <v-tab-item key="companies" :reverse-transition="true">
                  <user-companies :companies="userInfo.companies" />
                </v-tab-item>
                <v-tab-item key="wallet" :reverse-transition="true">
                  <user-wallet :user-id="userInfo.id" :balance="userInfo.balance"></user-wallet>
                </v-tab-item>
                <v-tab-item key="referred" :reverse-transition="true">
                  <user-referrals :items="userInfo.referrals"></user-referrals>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import UserCompanies from "@/components/users/UserCompanies.vue";
import UserWallet from "@/components/users/UserWallet.vue";
import UserInfo from "@/components/users/UserInfo.vue";
import UserReferrals from "@/components/users/UserReferrals.vue";

export default {
  name: "UserDetail",
  components: { UserCompanies, UserWallet, UserInfo, UserReferrals },
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      userInfo: null,
      tab: null,
    };
  },
  mounted() {
    this.getUesrInfo();
  },
  watch: {
    id() {
      this.getUesrInfo();
    },
  },
  methods: {
    getUesrInfo() {
      this.request({
        url: this.endpoint(`sobhanAdmin/users/${this.id}/`),
        method: "get",
        success: (data) => {
          this.userInfo = data;
        },
      });
    },
  },
};
</script>
